import type { EnvRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'environment'
const envSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const envRefs: EnvRefs = {
	reducedMotion: () => envSiteRefProvider(['reducedMotion']),
	userId: () => envSiteRefProvider(['userId']),
	experiments: () => envSiteRefProvider(['experiments']),
	editorType: () => envSiteRefProvider(['editorType']),
	domain: () => envSiteRefProvider(['domain']),
	previewMode: () => envSiteRefProvider(['previewMode']),
	stylableInstance: () => envSiteRefProvider(['stylableInstance']),
}
export { envRefs }
